import React from "react"
import type { PrimaryLogoProps } from "./PrimaryLogo.types"

export const PrimaryLogo: React.FunctionComponent<PrimaryLogoProps> = ({
  width = 120,
  height,
  className,
}) => {
  const computedHeight = height || (width * 307) / 338 // Maintain aspect ratio

  return (
    <img
      src="/logo.svg"
      alt="Mimber"
      width={width}
      height={computedHeight}
      className={className}
    />
  )
}
